// extracted by mini-css-extract-plugin
export var baseButton = "_vp-0";
export var controlsArrowKeys = "_vp-1";
export var controlsResetButton = "_vp-2";
export var lightGameButton = "_vp-4 _vp-0";
export var playAgainButton = "_vp-5 _vp-0";
export var startGameButton = "_vp-3 _vp-0";